export default function toFormData(data = {}, params = { clearEmptyArrays: true }) {
    const formData = new FormData();

    Object.entries(data).forEach(([field, value]) => {
        if (!value && (value !== 0 || value !== '')) {
            return;
        }

        if (Array.isArray(value)) {
            if (params.clearEmptyArrays && !value.length) {
                return;
            }

            value.forEach(item => {
                formData.append(field, item);
            });
            return;
        }

        formData.set(field, value);
    });

    return formData;
}
